<template>
  <div class="tab-content flex-direction is-active" id='mycomp-all-recann-list-template'>
    <div style="display:flex; align-items:center;">
<button type="button" class="btn btn-md" style="background-color:#6abf69; border-color:#6abf69; color:#fff; margin-left:auto; margin-bottom:16px;" @click="showAnnSelectPopup">
        <i class="ico ico-excel-wt"></i>
        엑셀 다운로드
      </button>
    </div>

    <!-- 공고 선택 팝업 -->
    <div class="modal__wrap--bg cmp-modal" :class="{'is-active': annSelectModal}">
      <div class="modal-wrap-container modal-wd1020">
        <div class="modal-header">
          <div class="title" style="font-size:22px; font-family:Pretendard, sans-serif; color:#000000; font-weight:bold;">공고 선택</div>
        </div>
        <div class="modal-body-container">
          <p style="font-size:18px; font-family:Pretendard, sans-serif; color:#151515; margin:40px 0px 0px;">다운로드할 공고를 선택해 주세요.</p>
          <div class="table-wrap scroll-table">
            <div class="no-data" v-if="annSelectList.length === 0">등록된 공고가 없습니다.</div>
            <table class="table-list" v-else>
              <caption>공고 목록</caption>
              <colgroup>
                <col style="width:15%">
                <col style="width:65%">
                <col style="width:20%">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">공고번호</th>
                  <th scope="col">공고명</th>
                  <th scope="col">선택</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in annSelectList" :key="item.ANN_NO">
                  <td class="text-c">{{ item.ANN_NO }}</td>
                  <td>{{ item.ANN_NM }}</td>
                  <td class="text-c">
                    <button type="button" class="btn btn-primary btn-xsm" @click="downloadExcelByAnn(item.ANN_NO)">다운로드</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-md button-wid150" @click="closeAnnSelect">닫기</button>
        </div>
        <button type="button" class="btn btn-close only-icon" aria-label="닫기" @click="closeAnnSelect" title="닫기">
          <i class="ico ico-x-bl"></i>
        </button>
      </div>
    </div>
    <div class="tab-container-sort">
      <div class="tab-menu-wrap scroll-tab">
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'ALL'}" @click="search('ALL')">전체</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'APPLY'}" @click="search('APPLY')">지원완료</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'ING'}" @click="search('ING')">심사 중</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'PASS'}" @click="search('PASS')">합격</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'FAIL'}" @click="search('FAIL')">불합격</button>
      </div>
    </div>
    <div class="tab-content sort-type">
      <div class="table-wrap no-line-mg scroll-table">
        <div class="button-area tit-type mt-40">
          <p class="txt">선택한 참여자의 심사상태</p>
          <div class="input-area">
            <select title="심사상태 선택" v-model="checkChangeStatus">
              <option value hidden selected>심사상태 선택</option>
              <option v-for="(status, index) in resumeStatus" :key="index" :value="status.code">{{ status.name }}</option>
            </select>
          </div>
          <button type="button" class="btn btn-gray btn-xsm" @click="checkChange">일괄변경</button>
        </div>
        <div class="no-data" v-if="list.length === 0">
          <template v-if="searchMode === 'ALL'">신청자 명단 없습니다</template>
          <template v-else>검색된 신청자 명단 없습니다</template>
        </div>
        <table class="table-list" v-else>
          <caption>신청자 현황</caption>
          <colgroup class="pc-cell">
            <col style="width:4%">
            <col style="width:6%">
            <col style="width:6%">
            <col style="width:12%">
            <col style="width:9%">
            <col style="width:6%">
            <col style="width:9%">
            <col style="width:9%">
            <col style="width:6%">
            <col style="width:7%">
            <col style="width:9%">
            <col style="width:12%">
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width:56px">
            <col style="width:80px">
            <col style="width:120px">
            <col style="width:195px">
            <col style="width:120px">
            <col style="width:80px">
            <col style="width:120px">
            <col style="width:120px">
            <col style="width:80px">
            <col style="width:96px">
            <col style="width:96px">
            <col style="width:160px">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">
                <div class="check-wrap tbl-chk chk-all">
                  <input type="checkbox" id="chk-all" v-model="allChecked" @click="checkedAll($event.target.checked)" title="chk-all 선택" />
                  <label for="chk-all"></label>
                </div>
              </th>
              <th scope="col">연번</th>
              <th scope="col">신청자명</th>
              <th scope="col">공고명</th>
              <th scope="col">공고별 신청현황</th>
              <th scope="col">성별</th>
              <th scope="col">생년월일</th>
              <th scope="col">이메일</th>
              <th scope="col">경력</th>
              <th scope="col">신청서</th>
              <th scope="col">심사상태</th>
              <th scope="col">심사 상태 변경</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.APP_NO">
              <td scope="col">
                <div class="check-wrap tbl-chk">
                  <input type="checkbox" :id="'item_'+item.APP_NO" v-model="item.checked" @change="checked($event)" title="선택 선택" />
                  <label :for="'item_'+item.APP_NO"></label>
                </div>
              </td>
              <td class="text-c">{{ item.rn }}</td>
              <td class="text-c">{{ item.APPLCNT_NM }}</td>
              <td @click="showAnnPreView(item.ANN_NO)">{{ item.ANN_NM }}</td>
              <td class="text-c">
                <button type="button" class="btn btn-gray btn-xsm" @click="goAppRecannList(item.ANN_NO)">상세보기</button>
              </td>
              <td class="text-c">{{ item.GENDER }}</td>
              <td class="text-c">{{ item.BIRTHDE }}</td>
              <td class="text-c">{{ item.EMAIL }}</td>
              <td class="text-c">{{ item.CARR_LABEL }}</td>
              <td class="text-c"><button type="button" class="btn btn-gray btn-xsm" @click="showAppView(item.APP_NO)">보기</button></td>
              <td class="text-c">{{ item.CORM_RST_STAT_LABEL }}</td>
              <td class="text-c">
                <div class="input-area">
                  <select title="심사상태 선택" v-model="item.seleteStatus">
                    <option value="">심사상태 선택</option>
                    <option v-for="(status, index) in resumeStatus" :key="index" :value="status.code">{{ status.name }}</option>
                  </select>
                  <button type="button" class="btn btn-gray btn-xsm" @click="oneChange(item)">변경</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 페이지네이션 -->
      <pagination :totalPages="paginationInfo.totalPageCount" :currentPage.sync="paginationInfo.currentPageNo" :size="paginationInfo.pageSize" @update:currentPage="handlePageChange"></pagination>
      <app-view :appViewModal="appViewModal" :appNo="appNo" :annKindType="annKindType" @update:appViewModal="appViewModal = $event" :mode="'comp'"></app-view>
      <ann-pre-view :annPreViewModal="annPreViewModal" :annNo="annNo" @update:annPreViewModal="annPreViewModal = $event"></ann-pre-view>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import AppView from '../APP/AppView.vue';
import CompAppFormBtn from '../components/CompAppFormBtn.vue';
import Pagination from '../../shared/Pagination.vue';
import { changeStatue } from '../../../api/compAppRecann';
import AnnPreView from '../../components/AnnPreView.vue';

const resumeStatus = [
  {
    code: 'ING',
    name: '심사중',
  },
  {
    code: 'PASS',
    name: '합격',
  },
  {
    code: 'FAIL',
    name: '불합격',
  },
];

const statusMode = {
  ALL: { CUR_STAT_CD: null, LAST_RST_STAT: null, name: '전체' },
  APPLY: { CUR_STAT_CD: 'IN22001', LAST_RST_STAT: null, name: '지원완료' },
  ING: { CUR_STAT_CD: 'IN22002', LAST_RST_STAT: null, name: '심사 중' },
  PASS: { CUR_STAT_CD: null, LAST_RST_STAT: 'IN27002', name: '합격' },
  FAIL: { CUR_STAT_CD: null, LAST_RST_STAT: 'IN27001', name: '불합격' },
};


export default {
  name: 'mycomp-all-recann-list-template',
  props: [],
  components: {
    AppView,
    AnnPreView,
    CompAppFormBtn,
    Pagination,
  },
  data() {
    return {
      searchMode: 'ALL',
      resumeStatus,
      statusMode,
      paginationInfo: {},
      pagingParam: {
        pageIndex: 1, // 현재 페이지
      },
      pageIndex: 1,
      list: [],
      totalCnt: 0,
      appNos: '',
      changeStatus: '',
      allChecked: false,
      checkChangeStatus: '', // 선택된 이력서의 상태 변경값
      SRCH_CUR_STAT_CD: null,
      SRCH_LAST_RST_STAT: null,
      appViewModal: false,
      annPreViewModal: false,
      appNo: 0,
      annKindType: 'IN',
      annNo: 0,
      annSelectModal: false,
      annSelectList: [],
    };
  },
  watch: {
    appViewModal(newVal) {
        if (!newVal) {
            $('body').removeClass('modal-open');
        }
    }
  },
  computed: {
    seletedItems() {
      return this.list.filter(item => item.checked).map(item => item.APP_NO);
    }
  },
  methods: {
    checkedAll(checked) {
      this.allChecked = checked;
      this.list.forEach(item => {
        item.checked = this.allChecked;
      });
    },
    checked() {
      const count = this.list.filter(item => item.checked);
      this.allChecked = (count === this.list.length);
    },
    search(mode) {
      this.searchMode = mode;
      this.SRCH_CUR_STAT_CD = this.statusMode[mode].CUR_STAT_CD;
      this.SRCH_LAST_RST_STAT = this.statusMode[mode].LAST_RST_STAT;
      this.pagingParam.pageIndex = 1;
      this.getList();
    },
    getList() {
      const params = {
        SRCH_CUR_STAT_CD: this.SRCH_CUR_STAT_CD,
        SRCH_LAST_RST_STAT: this.SRCH_LAST_RST_STAT,
        sortOrder: 'DESC',
        ...this.pagingParam,
      };

      Axios.get('/api/comp/recannAppList', { params }).then((response) => {
        this.paginationInfo = response.data.paginationInfo;
        this.totalCnt = response.data.paginationInfo.totalRecordCount;
        this.list = response.data.list.map(item => {
          const rn = (this.totalCnt + 1) - item.RN;
          const seleteStatus = '';
          const checked = false;
          const newItem = {
            ...item,
            rn,
            seleteStatus,
            checked,
          };
          return newItem;
        });
      }).catch((error) => {
        console.log(error.data);
      });
    },
    async statusChange() {
      if (this.appNos === '') {
        alert('변경할 신청서를 선택해주세요.');
        return;
      }

      if (this.changeStatus === '') {
        alert('변경할 심사 상태 값을 선택해주세요.');
        return;
      }

      try {
        const result = await changeStatue(this.appNos, this.changeStatus);
        if (result.success) {
          alert(result.message);
          this.getList();
        }
      } catch (error) {
        console.error('심사상태 변경 오류:', error);
        alert(error.message || '심사상태 변경에 실패했습니다.');
      }
    },
    checkChange() {
      this.appNos = this.seletedItems.join(',');
      this.changeStatus = this.checkChangeStatus;
      this.statusChange();
    },
    oneChange(item) {
      this.appNos = item.APP_NO;
      this.changeStatus = item.seleteStatus;
      this.statusChange();
    },
    handlePageChange(newPage) {
      this.pagingParam.pageIndex = newPage;
      this.pageIndex = newPage;
      this.getList();
    },
    /**
     * 공고 등록 폼 표시 요청을 부모 컴포넌트로 전달
     */
    handleShowAppForm() {
      this.$emit('showAppForm');
    },
    goAppRecannList(annNo) {
      location.href = `/mypage-comp-app-recann.do?ANN_NO=${annNo}`;
    },
    showAppView(appNo) {
      $('body').addClass('modal-open');
      this.appViewModal = true;
      this.appNo = appNo;
    },
    showAnnPreView(annNo) {
      $('body').addClass('modal-open');
      this.annPreViewModal = true;
      this.annNo = annNo;
    },
    showAnnSelectPopup() {
      Axios.get('/api/comp/in_appListAjax', { params: { pageIndex: 1, pageUnit: 999 } }).then((response) => {
        if (response.data.success === 'R') {
          this.annSelectList = response.data.list;
        } else {
          this.annSelectList = [];
        }
        $('body').addClass('modal-open');
        this.annSelectModal = true;
      }).catch(() => {
        alert('공고 목록을 불러오는 데 실패했습니다.');
      });
    },
    closeAnnSelect() {
      $('body').removeClass('modal-open');
      this.annSelectModal = false;
    },
    downloadExcelByAnn(annNo) {
      this.closeAnnSelect();
      location.href = '/compRecannAppListExcel?ANN_NO=' + annNo;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// MyCompRecannList.vue?77b87df6